import commonApi from './CommonApi.js';

export default {
	getForTagInput: async (parameter) => {
		return await commonApi().get('/v1/symbols/getForTagInput', { params: parameter })
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error);
				return {};
			});
	},
	checkSymbol: async (parameter) => {
		return await commonApi().get('/v1/symbols/checkSymbol', { params: parameter })
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error);
				return {};
			});
	},
}